import { Transition } from '@uirouter/angular';
import { ResolvableLiteral } from '@uirouter/angular';

import { LoginRedirectService } from 'rev-shared/security/LoginRedirect.Service';

import { InitiateResetPasswordComponent } from './InitiateResetPassword.Component';
import { LoginComponent, LoginResolve } from './Login.Component';
import { SSOLogoutComponent, SSOLogoutResolve } from './SSOLogout.Component';
import { UserAgreementComponent, UserAgreementResolve } from './UserAgreement.Component';
import { IVbNg2StateDeclaration } from 'rev-shared/ts-utils/IVbNg2StateDeclaration';


export function getCommonSecurityStatesNg2(
	initializationResolve: ResolvableLiteral[],
	loginComponent: typeof LoginComponent = LoginComponent,
	userAgreementComponent: typeof UserAgreementComponent = UserAgreementComponent
): IVbNg2StateDeclaration[] {
	return [
		{
			name: 'login',
			component: loginComponent,
			url: '/login?fwdUrl&initiateLogin',
			params: {
				fwdUrl: {
					value: '',
					replace: [{ // prevents the empty string from being replaced with undefined
						from: '',
						to: ''
					}]
				},
				forceLogout: undefined,
				initiateLogin: { value: false, type: 'bool', squash: true }
			},
			resolve: [
				...initializationResolve,
				...LoginResolve
			],
			allowAllAccess: true
		},

		{
			name: 'initiate-password-reset',
			url: '/initiate-password-reset',
			component: InitiateResetPasswordComponent,
			authorizationKey: 'resetPassword',
			allowAllAccess: true,
			params: {
				isChangePassword: false,
				prefillUsername: ''
			},
			resolve: [
				...initializationResolve,
				{
					token: 'isChangePassword',
					deps: [Transition],
					resolveFn: (transition: Transition) => transition.params().isChangePassword
				},
				{
					token: 'prefillUsername',
					deps: [Transition],
					resolveFn: (transition: Transition) => transition.params().prefillUsername
				},
			]
		},

		{
			name: 'user-agreement',
			url: '/user-agreement?fwdUrl&userId&ssoLogin',
			resolve: [
				...initializationResolve,
				...UserAgreementResolve
			],
			component: userAgreementComponent,
			allowAllAccess: true,
			params: {
				fwdUrl: { value: '', squash: true },
				userId: { value: '', squash: true },
				ssoLogin: { value: false, type: 'bool', squash: true }
			}
		},

		{
			name: 'logout',
			params: {
				fwdUrl: undefined,
				sessionEnded: undefined,
				forceLogout: undefined
			},
			resolve: initializationResolve,
			redirectTo(transition: Transition) {
				const loginRedirectService = transition.injector().get<LoginRedirectService>(LoginRedirectService);

				return loginRedirectService.getLogoutRedirect(transition.params());
			}
		},

		{
			name: 'sso-logout',
			url:'/sso-logout?sessionEnded&fwdUrl',
			params: {
				fwdUrl: {
					value: '',
					replace: [{ // prevents the empty string from being replaced with undefined
						from: '',
						to: ''
					}]
				}
			},
			resolve: [
				...initializationResolve,
				...SSOLogoutResolve
			],
			component: SSOLogoutComponent,
			allowAllAccess: true
		},

		//Empty state for <a> tags with no href.
		//Workaround for links defined with href=javascript:, Prevents CSP errors.
		//Do not use this. all <a> tags should have valid href or uiSref. If there is no href, use a <button> element instead.
		{
			name: 'void',
			url: '/void',
			allowAllAccess: true,
			onEnter() {
				return false;
			}
		}
	];
}
